// Fontawesome 5
import './shared/font-awesome';

// Style
import '../scss/app.scss';

// App Config
import AppConfig from './app.config';

// App Controller
const AppController = require('./app.controller');

// App Filters
const RelativeDate = require('./shared/filters/RelativeDate');
const PriceSeperator = require('./shared/filters/PriceSeperator');
const FormatDate = require('./shared/filters/FormatDate');
const FormatDateFarsi = require('./shared/filters/FormatDateFarsi');
const limitText = require('./shared/filters/limitText');


// Auth
const authHttpResponseInterceptor = require('./shared/auth/authHttpResponseInterceptor');


// ImportExternalComponentJS
import headerComponent from '../../Sooran.FrontTinet.ClientShare/Header/header.component';
import NoticesModule from "../../Sooran.FrontTinet.Notices/Notices.module";


// ImportModuleJS
import module_nameModule from "./components/module_name/module_name.module";

import SponserModule from "./components/Sponser/Sponser.module";
import BrokerModule from "./components/Broker/Broker.module";
import AplicantModule from "./components/Aplicant/Aplicant.module";

import DashboardModule from "./components/Dashboard/Dashboard.module";

import AppRun from './app.run';



/**
 * @api {get} /user/:id Request User information
 * @apiName GetUser
 * @apiGroup User
 * @apiDeprecated use now (#Group:Name).  
 * @apiDescription This is the Description.
 * @apiParam {Number} id Users unique ID.
 *
 * @apiSuccess {String} firstname Firstname of the User.
 * @apiSuccess {String} lastname  Lastname of the User.
 */


const ngModule = angular
  .module("app", [

    /* Shared modules */
    //"app.core",
    "ui.router",
    "oc.lazyLoad",
    "ngResource",
    "ngMaterial",
    "ngMessages",
    "ngAria",
    require('angular-sanitize'),
    "ngAnimate",
    'ADM-dateTimePicker',
    "angular-loading-bar",
    "ngTable",
    "cgBusy",
    "angularPromiseButtons",
    "angularPagination",
    "ngOidc",
    'ngFileUpload',
    "ngCookies",
    "angular-intro",
    /* Feature areas*/
    "module_nameModule", 
    "NoticesModule", , ,
    "SponserModule",
    "BrokerModule",
    "AplicantModule",
    "module_nameModule",
    "DashboardModule"
  ]);

// Inject Components
headerComponent(ngModule)


ngModule.config(AppConfig);
ngModule.run(AppRun);
AppController(ngModule);
RelativeDate(ngModule);
PriceSeperator(ngModule);
FormatDate(ngModule);
FormatDateFarsi(ngModule);
limitText(ngModule);
authHttpResponseInterceptor(ngModule);

// checkImage Directive
require('./shared/Directive/checkImage')(ngModule);



export {
  ngModule
};